import React, { useState, useEffect } from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
//import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
// @material-ui/icons
import AllInbox from "@material-ui/icons/AllInbox";
import AllOut from "@material-ui/icons/AllOut";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AttachMoney from "@material-ui/icons/AttachMoney";

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CircularProgress from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";

import { getRps } from "services/rps";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { getOrdersbyStatusAsync } from "services/orders/orders";

import { dailyChart } from "./chart";
import { getConfigAsync } from "services/config";
import { Info } from "@material-ui/icons";
import ExportCsv from "exportCsv.js";
import DateCus from "components/Date/Date";

const useStyles = makeStyles(styles);

export default function SellReport(props) {
  const [rps, setRps] = useState([]);
  const [countDay, setCountDay] = useState({});
  const [paymentIn, setPaymentIn] = useState(0);
  const [paymentOut, setPaymentOut] = useState(0);
  const [paymentInData, setPaymentInData] = useState([]);
  const [paymentOutData, setPaymentOutData] = useState([0]);
  const [ordersAllocatedRaw, setOrdersAllocatedRaw] = useState([]);
  const [ordersCollectedRaw, setOrdersCollectedRaw] = useState([]);
  const [ordersAllocated, setOrdersAllocated] = useState([]);
  const [ordersCollected, setOrdersCollected] = useState([]);
  const [circular, setCircular] = useState(true);
  const [config, setConfig] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [exp, setExport] = React.useState(false);
  const [openDate, setOpenDate] = React.useState(false);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickExportCSV = e => {
    handleClick(e);
    setExport(true);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const classes = useStyles();

  useEffect(() => {
    async function getData() {

      const [_rps, _config, _ordersAllocated, _ordersCollected] = await Promise.all([
        getRps(),
        getConfigAsync(),
        getOrdersbyStatusAsync(props.lockerId, 'allocated'),
        getOrdersbyStatusAsync(props.lockerId, 'collected')
      ]);

      const _paymentInData = _rps.filter(r => r.descricaoItem ==='GUARDA_VOLUMES_CONVENCIONAL');
      const _paymentOutData = _rps.filter(r => r.descricaoItem ==='GUARDA_VOLUMES_ARMAZENADO');

      const _paymentIn = _paymentInData.length;
      const _paymentOut = _paymentOutData.length;

      handleChart(_ordersCollected);

      setConfig(_config);
      setOrdersAllocatedRaw(_ordersAllocated);
      setOrdersCollectedRaw(_ordersCollected);
      setOrdersAllocated(_ordersAllocated);
      setOrdersCollected(_ordersCollected);
      setPaymentIn(_paymentIn);
      setPaymentOut(_paymentOut);
      setPaymentInData(_paymentInData);
      setPaymentOutData(_paymentOutData);
      setRps(_rps);
      setCircular(false);
    };

    getData();

  }, [props.lockerId]);

  function handleChart(ordersCollectedArray) {
    let _countDay = {
      labels: [],
      series: []
    }
    _countDay.labels.push("Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado");
    _countDay.series = [0, 0, 0, 0, 0, 0, 0];

    ordersCollectedArray.forEach(element => {
      let dateAllocated = new Date(element.allocatedAt);
      switch (dateAllocated.getDay()) {
        case 0:
          _countDay.series[0]++;
          break;
        case 1:
          _countDay.series[1]++;
          break;
        case 2:
          _countDay.series[2]++;
          break;
        case 3:
          _countDay.series[3]++;
          break;
        case 4:
          _countDay.series[4]++;
          break;
        case 5:
          _countDay.series[5]++;
          break;
        case 6:
          _countDay.series[6]++;
          break;

        default:
          break;
      }
    });

    setCountDay(_countDay);
  }

  async function handle1Dia() {
    let now = new Date();
    let _ordersAllocated = ordersAllocatedRaw.filter(o => new Date(o.allocatedAt) ===now);
    let _ordersCollected = ordersCollectedRaw.filter(o => new Date(o.collectedAt) ===now);
    let _paymentIn = paymentInData.filter(r => new Date(r.data) ===now).length;
    let _paymentOut = paymentOutData.filter(r => new Date(r.data) ===now).length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  async function handle7Dias() {
    let now = new Date();
    now.setDate(now.getDate() - 7);
    let _ordersAllocated = ordersAllocatedRaw.filter(o => new Date(o.allocatedAt) >= now);
    let _ordersCollected = ordersCollectedRaw.filter(o => new Date(o.collectedAt) >= now);
    let _paymentIn = paymentInData.filter(r => new Date(r.data) >= now).length;
    let _paymentOut = paymentOutData.filter(r => new Date(r.data) >= now).length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  async function handle1Mes() {
    let now = new Date();
    now.setDate(now.getDate() - 30);
    let _ordersAllocated = ordersAllocatedRaw.filter(o => new Date(o.allocatedAt) >= now);
    let _ordersCollected = ordersCollectedRaw.filter(o => new Date(o.collectedAt) >= now);
    let _paymentIn = paymentInData.filter(r => new Date(r.data) >= now).length;
    let _paymentOut = paymentOutData.filter(r => new Date(r.data) >= now).length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  async function handle6Meses() {
    let now = new Date();
    now.setDate(now.getDate() - 180);
    let _ordersAllocated = ordersAllocatedRaw.filter(o => new Date(o.allocatedAt) >= now);
    let _ordersCollected = ordersCollectedRaw.filter(o => new Date(o.collectedAt) >= now);
    let _paymentIn = paymentInData.filter(r => new Date(r.data) >= now).length;
    let _paymentOut = paymentOutData.filter(r => new Date(r.data) >= now).length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  async function handle1Ano() {
    let now = new Date();
    now.setDate(now.getDate() - 365);
    let _ordersAllocated = ordersAllocatedRaw.filter(o => new Date(o.allocatedAt) >= now);
    let _ordersCollected = ordersCollectedRaw.filter(o => new Date(o.collectedAt) >= now);
    let _paymentIn = paymentInData.filter(r => new Date(r.data) >= now).length;
    let _paymentOut = paymentOutData.filter(r => new Date(r.data) >= now).length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  async function handleAll() {
    let _ordersAllocated = ordersAllocatedRaw;
    let _ordersCollected = ordersCollectedRaw;
    let _paymentIn = paymentInData.length;
    let _paymentOut = paymentOutData.length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  async function handleCustomaze(dateFrom, dateTo) {
    let _ordersAllocated = ordersAllocatedRaw.filter(o => handledates(dateFrom, dateTo, new Date(o.allocatedAt)));
    let _ordersCollected = ordersCollectedRaw.filter(o => handledates(dateFrom, dateTo, new Date(o.collectedAt)));
    let _paymentIn = paymentInData.filter(r => handledates(dateFrom, dateTo, new Date(r.data))).length;
    let _paymentOut = paymentOutData.filter(r => handledates(dateFrom, dateTo, new Date(r.data))).length;
    handleData(_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut);
  }

  const handledates = (dateFrom, dateTo, compareDate) => {
    if(compareDate >= dateFrom && compareDate <= dateTo){
      return true;
    }
    return false;
  }

  const handleData = (_ordersCollected, _ordersAllocated, _paymentIn, _paymentOut) => {
    handleChart(_ordersCollected);
    setOrdersAllocated(_ordersAllocated);
    setOrdersCollected(_ordersCollected);
    setPaymentIn(_paymentIn);
    setPaymentOut(_paymentOut);

    if(exp) {
      let data = {};
      Object.assign(data, { volumesRetirados: ordersCollected.length, volumesAlocados: ordersAllocated.length, 
        pagamentoEntrada: 'R$ ' + (paymentIn * config.valorServico), pagamentoSaida: 'R$ ' + (paymentOut * config.valorServico),
        volumesDomingo: countDay.series[0], volumesSegunda: countDay.series[1], volumesTerça: countDay.series[3],
        volumesQuarta: countDay.series[4], volumesSexta: countDay.series[5], volumesSabado: countDay.series[6]
      });

      ExportCsv([data]);
    }
    
    handleClose();
    setExport(false);
  }


  return ((circular) ?
    <div>
      <CircularProgress />
    </div>
    : <div>
      <Button color="primary" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        Filtrar por período
      </Button>
      <Button color="default" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClickExportCSV}>
        Exportar csv
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleAll}>Todos</MenuItem>
        <MenuItem onClick={handle1Dia}>1 Dia</MenuItem>
        <MenuItem onClick={handle7Dias}>7 Dias</MenuItem>
        <MenuItem onClick={handle1Mes}>1 Mes</MenuItem>
        <MenuItem onClick={handle6Meses}>6 Meses</MenuItem>
        <MenuItem onClick={handle1Ano}>1 Ano</MenuItem>
        <MenuItem onClick={() => setOpenDate(true)}>Customizado</MenuItem>
      </Menu>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AllInbox />
              </CardIcon>
              <p className={classes.cardCategory}>Volumes alocados</p>
              <h3 className={classes.cardTitle}>
                {ordersAllocated.length}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Info />
                
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AllOut />
              </CardIcon>
              <p className={classes.cardCategory}>Volumes retirados</p>
              <h3 className={classes.cardTitle}>{ordersCollected.length}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Info />
                
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <MonetizationOn />
              </CardIcon>
              <p className={classes.cardCategory}>Pagamentos Entrada</p>
              <h3 className={classes.cardTitle}>{'R$ ' + (paymentIn * config.valorServico)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Info />
                {paymentIn + ' volumes x ' + config.valorServico}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <AttachMoney />
              </CardIcon>
              <p className={classes.cardCategory}>Pagamentos Saída</p>
              <h3 className={classes.cardTitle}>{'R$ ' + (paymentOut * config.valorServico)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Info />
                {paymentOut + ' volumes x ' + config.valorServico}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <AttachMoney />
              </CardIcon>
              <p className={classes.cardCategory}>Pagamentos Total</p>
              <h3 className={classes.cardTitle}>{'R$ ' + ((paymentOut + paymentIn) * config.valorServico)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Info />
                {(paymentOut + paymentIn) + ' volumes x ' + config.valorServico}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Card chart>
        <CardHeader color="warning">
          <ChartistGraph
            className="ct-chart"
            data={countDay}
            type="Bar"
            options={dailyChart.options}
            responsiveOptions={dailyChart.responsiveOptions}
            listener={dailyChart.animation}
          />
        </CardHeader>
        <CardBody>
          <h4 className={classes.cardTitle}>Volumes alocados por dia da semana</h4>
          <p className={classes.cardCategory}>Desde o início das operações</p>
        </CardBody>
      </Card>
      {(openDate) ? 
      <DateCus 
        open={openDate} 
        onChangeDate={handleCustomaze}
        onChange={() => setOpenDate(false)}
      /> : null}
      <GridContainer></GridContainer>
    </div>);
}